export class Loanscheme {
    Id:Number ;
    SchemeName:string ;
    SchemeCode:string ;
    LoanTypeId:Number ;
    LoanCategoryId:Number ;
    MinValue:Number ;
    MaxValue:Number ;
    LoanPeriod:Number ;
    PeriodTypeId:Number ;
    ExpiryPeriod:Number ;
    InterestPrecentage:Number ;
    DelayInterest:Number ;
    FlatInterest:Number ;
    MinimumInterestAmount:Number ;
    MinimumCloseAmount:Number ;
    EMITypeId:Number ;
    InstallmentAmount:Number ;
    InstallmentBaseAmount:Number ;
    InstallmentPremiumAmount:Number ;
    CalculationMethodId:Number ;
    DefaultFee:Number ;
    AdvanceEMI:Number ;
    GracePeriod:Number ;
    CompanyId:Number ;
    EmployeeBranchId:Number ;
    EmployeeId:Number ;
    SaasId:Number ;
    IsActive:Number ;
    Flag : Number;
}
